<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <b-button
              variant="primary"
              class="btn-sm mb-2"
              @click="grvFromOrder = true"
            >
              GRV From order
            </b-button>

            <form-group label="Parts from order" v-if="grvFromOrder">
              <b-form-select v-model="selectedOrder">
                <b-form-select-option
                  v-for="order in orders"
                  :value="order"
                  :key="order.id"
                  >Order#{{ order.order_number }}
                  <span v-if="order.job">Job#{{ order.job.job_number }}</span>
                  - {{ order.supplier.name }}
                </b-form-select-option>
              </b-form-select>
            </form-group>

            <form-group label="Supplier" :required="true">
              <b-form-select
                @blur="$v.grv.supplier_id.$touch"
                :class="{ 'is-invalid': $v.grv.supplier_id.$error }"
                v-model="grv.supplier_id"
              >
                <b-form-select-option
                  v-for="supplier in suppliers"
                  :value="supplier.id"
                  :key="supplier.id"
                  >{{ supplier.name }}</b-form-select-option
                >
              </b-form-select>
              <div class="invalid-feedback" v-if="!$v.grv.supplier_id.required">
                Please select supplier
              </div>
            </form-group>

            <form-group label="Reference">
              <input type="text" class="form-control" v-model="grv.reference"/>
            </form-group>

            <div>
              <table
                class="table table-sm border"
                v-if="selectedParts.length > 0"
              >
                <tr class="bg-light font-weight-bold">
                  <td>Part</td>
                  <td>Quantity</td>
                  <td>Cost</td>
                  <td>Total</td>
                  <td></td>
                </tr>
                <tr v-for="part in selectedParts" :key="part.key">
                  <td>{{ part.code }} - {{ part.description }}</td>
                  <td>
                    {{ part.quantity }}
                  </td>
                  <td>
                    {{ part.cost_price }}
                  </td>
                  <td>
                    {{ part.quantity * part.cost_price }}
                  </td>
                  <td class="text-right">
                    <i
                      class="lni lni-trash text-danger pointer"
                      @click="removePart(part)"
                    ></i>
                  </td>
                </tr>
              </table>
            </div>

            <div class="border p-3 my-3" v-if="selectedOrder && selectedOrder.order_items.length>0">
              <h3>Add Pricing:</h3>
              <table class="table">
                <tr class="bg-light font-weight-bold">
                  <td>Part</td>
                  <td>Qty</td>
                  <td>Cost</td>
                  <td></td>
                </tr>
                <tr v-for="part in selectedOrder.order_items" :key="part.id">
                  <td>
                    <strong> {{ part.part.code }} </strong> -
                    {{ part.part.description }}
                  </td>
                  <td>
                    {{ part.quantity }}
                  </td>
                  <td>
                    <input type="number" min="0" v-model="part.cost_price" class="form-control form-control-sm" style="height:32px;">
                  </td>
                  <td>
                      <b-button
                        variant="info"
                        class="btn-sm float-right text-white"
                        @click="addOrderPart(part.part_id)"
                        >Add</b-button
                      >
                  </td>
                </tr>
              </table>
            </div>

            <div class="border p-3 my-3">
              <h3>Select Parts:</h3>
              <form-group label="Parts Search">

                
                 <span v-if="selectedPart">
                  {{ selectedPart.code }} - {{selectedPart.description}}
                </span>

                <v-select
                  ref="part"
                  label="name"
                  :options="parts"
                  :filterable="false"
                  @search="getParts"
                  :value="selectedPart"
                  @input="setSelected"
                >
                  <template slot="no-options">
                    Type to search parts by code or description
                  </template>
                  <template slot="option" slot-scope="c">
                    <div>{{ c.code }} - {{ c.description }}</div>
                  </template>
                  <template slot="selected-option" slot-scope="c">
                    {{ c.description }}
                  </template>
                </v-select>
              </form-group>

              
              <div class="py-3"></div>

              <form-group label="Quantity" :required="true">
                <b-form-spinbutton
                  ref="quantity"
                  class="form-control"
                  type="number"
                  min="1"
                  max="100000"
                  step="1"
                  v-model="selectedQuanity"
                />
              </form-group>

              <form-group label="Cost Per Part" :required="true">
                <input
                  class="form-control"
                  type="number"
                  min="0"
                  v-model="costPrice"
                />
              </form-group>

              <b-button
                variant="info"
                class="btn-sm float-right text-white"
                @click="addPart"
                >Add</b-button
              >
              <div style="clear: both"></div>
            </div>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import goodsReceivedRepo from "@/api/repos/goodsReceivedRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    grv: {
      supplier_id: {
        required,
      },
    },
  },

  mounted() {
    this.getCreatedData();
  },

  data() {
    return {
      grvFromOrder: false,
      orders: [],
      selectedOrder: null,
      selectedGrv: null,
      parts: [],
      selectedPart: null,
      costPrice: "",
      selectedQuanity: 1,
      selectedParts: [],
      suppliers: [],
      grv: {},
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
      partKey:1
    };
  },

  methods: {
    async getCreatedData() {
      try {
        this.loading = true;
        let { data } = await goodsReceivedRepo.createRelatedData();
        this.suppliers = data.suppliers;
        this.orders = data.orders;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
     setSelected(value) {
      this.selectedPart = value
      this.parts=[]
      this.$refs.quantity.focus()
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";

      if (this.selectedParts.length == 0) {
        this.$root.$bvToast.toast("No Parts", {
          title: "No Parts",
          autoHideDelay: 2000,
          variant: "danger",
        });
        this.loading = false;
        this.submitStatus = null;
        return;
      }
      this.grv.parts = this.selectedParts;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await goodsReceivedRepo.create(this.grv);
          this.$emit("goodsReceivedCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
    getParts(search) {
      if (search.length > 1) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          this.partSearch(search);
        },250);
      }
    },
    addPart() {
      if (this.selectedPart == null || this.costPrice == null) {
        this.$root.$bvToast.toast("Missing info", {
          title: "Fill in info",
          autoHideDelay: 3000,
          variant: "danger",
        });

        return false;
      }
      this.partKey=this.partKey+1;
      this.selectedParts.push({
        key: this.partKey,
        id: this.selectedPart.id,
        code: this.selectedPart.code,
        description: this.selectedPart.description,
        quantity: this.selectedQuanity,
        cost_price: this.costPrice,
      });

      this.selectedPart = null;
      this.costPrice = "";
          this.parts=[]
      this.$refs.part.$refs.search.focus()
    },

    addOrderPart(id) {

     
      let order;

      this.selectedOrder.order_items.forEach(x => {
        if(x.part_id == id){order = x}
      });

      if (!order.cost_price) {
        this.$root.$bvToast.toast("Missing info", {
          title: "Fill in info",
          autoHideDelay: 3000,
          variant: "danger",
        });

        return false;
      }

      this.partKey=this.partKey+1;
      this.selectedParts.push({
        key: this.partKey,
        id: order.part_id,
        code: order.part.code,
        description: order.part.description,
        quantity: order.quantity,
        cost_price: order.cost_price,
      });

       this.selectedOrder.order_items = this.selectedOrder.order_items.filter(x => {
        return x.part_id != id
      });

      this.selectedPart = null;
      this.costPrice = "";
  
    },

    removePart(part) {
      this.selectedParts = this.selectedParts.filter((x) => x != part);
    },

    async partSearch(search) {
      try {
        let { data } = await goodsReceivedRepo.getParts(search);
        this.parts = data.parts;
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    // whenever question changes, this function will run
    selectedOrder: function (val) {
      if (val != null) {
        this.selectedParts = [];
        this.grv.order_id = this.selectedOrder.id
     
      }
    },
  },
};
</script>

<style></style>
